import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";

interface PasswordModalProps {
  open: boolean;
  password: string | null;
  title: string;
  onClose: () => void;
}

const PasswordModal: React.FC<PasswordModalProps> = ({
  open,
  password,
  title,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (open) setCopied(false);
  }, [open]);

  const handleCopy = () => {
    if (password) {
      navigator.clipboard.writeText(password);
      setCopied(true);
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={onClose}
      onCancel={onClose}
      okText="Entendido"
      okButtonProps={{ disabled: !copied }}
      cancelButtonProps={{ style: { display: "none" } }}
      closable={false}
      maskClosable={false}
    >
      <p>Se generó una contraseña automática:</p>

      <div style={{ fontSize: 18, fontWeight: 700, margin: "8px 0" }}>
        {password}
      </div>

      <Button
        type={copied ? "default" : "primary"}
        icon={copied ? <CheckOutlined /> : <CopyOutlined />}
        onClick={handleCopy}
      >
        {copied ? "¡Copiada!" : "Copiar contraseña"}
      </Button>

      <p
        style={{
          marginTop: 12,
          fontWeight: 600,
          color: copied ? "#389e0d" : "#d46b08",
        }}
      >
        {copied
          ? "✅ Contraseña copiada al portapapeles."
          : "⚠️ Copiala ahora. No se volverá a mostrar."}
      </p>
    </Modal>
  );
};

export default PasswordModal;
